import styled from '@emotion/styled'

export const BannerLink = styled.a`
  color: #2979ff;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 100% */
`
